import RoutesPath from "./routes/route";

const App = () => {
  return (
    <>
      <RoutesPath />
    </>
  )
};

export default App;